<script>
	import { fade } from 'svelte/transition';
	import { fecthUserTokens } from '../../utils/api.js';
	import { onCopyClick, formatNumberToTwoDecimals } from '../../utils/utils.js';
	import TokenCreate from './TokenCreate.svelte';
	import TokenDelete from './TokenDelete.svelte';
	import {
		Loaders,
		TableView,
		Icon,
		InlineNotification,
		HorizontalChartBar
	} from '@shopboxai/sb-portal-components';
	const months = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	];
	let colors = [
		'#0C01A3',
		'#EFCB39',
		'#52B4A1',
		'#EF465A',
		'#FC8865',
		'#A4D32E',
		'#7537F2',
		'#5EC0ED',
		'#25BA60',
		'#FED298',
		'#9E1816',
		'#22569B',
		'#027F79',
		'#CF9D06',
		'#CED2F0',
		'#F86C66',
		'#81DB6A',
		'#FFDC83',
		'#951800',
		'#F64740'
	];

	let maxRequest = 5000;
	let totalRequests = 0;

	let fetchTokens = async () => {
		let data = await fecthUserTokens();

		console.log('table', data);
		maxRequest = data.max_request_per_month;
		totalRequests = data.total_requests;
		return data;
	};
	let runFetchUserTokens = fetchTokens();

	const handleComplete = async () => {
		runFetchUserTokens = fetchTokens();
	};
	const formatDate = (date) => {
		let d = new Date(date);
		return d.toLocaleDateString('en-GB');
	};
	const getMonth = (date) => {
		let m = new Date(date);
		return months[m.getMonth()];
	};
	const getValues = (tokens) => {
		let values = [];
		tokens.forEach((element) => {
			values.push(element.request_count);
		});
		return values;
	};

	let visible = false;
	let limitExceeded = maxRequest <= totalRequests ? true : false;
</script>

<TokenCreate on:complete={handleComplete} bind:visible />

{#await runFetchUserTokens}
	<Loaders items={[{ size: 20, height: '150px' }]} />
{:then data}
	<TableView
		tableName="Platform API Keys"
		tableActionName="Generate new API tokens"
		on:tableAction={() => (visible = true)}
	>
		<div slot="content" class="statistics">
			<div class="statistics-header">
				<div>
					<h3>API Calls</h3>
					<p class="usage"><span>{totalRequests}</span> / <span>{maxRequest}</span></p>
				</div>
				<p class="usage-period">
					Period : <span>1 {getMonth(data.period.from)}</span> -
					<span>{data.period.to.slice(8)} {getMonth(data.period.to)}</span>
				</p>
			</div>
			<HorizontalChartBar max={maxRequest} {colors} values={getValues(data.tokens)} />
			{#if limitExceeded}
				<!-- content here -->
				<InlineNotification
					icon={'api_danger'}
					background={'danger'}
					message={"You've exceeded the number of API calls included in your Growth package. To expand your package, please contact Customer Support. Let's find the right solution for you!"}
				>
					<a href="/help" class="api-cta"> Customer Support </a>
				</InlineNotification>
			{/if}
		</div>
		<thead slot="thead">
			{#if data.tokens.length}
				<tr>
					<th>Token name</th>
					<th>Date created</th>
					<th>Expiry date</th>
					<th>API calls</th>
					<th />
				</tr>
			{/if}
		</thead>

		<tbody slot="tbody">
			{#each data.tokens as token, i}
				<tr in:fade>
					<td class="token-info">
						<span class="token-color" style="--bg-color: {colors[i]}" />
						<div>
							<p class="token-name">{token.name}</p>
							<span class="token">{token.token}</span>
						</div>
						<button
							title="Copy API key"
							class="copy-token"
							on:click={() => onCopyClick(token.token)}><Icon name="copy" /></button
						>
					</td>
					<td> {formatDate(token.created_at)}</td>
					<td>{token.expiry ? token.expity : '-'}</td>
					<td> {token.request_count} / {formatNumberToTwoDecimals(token.percentage)} %</td>
					<td class="right">
						<TokenDelete
							on:complete={handleComplete}
							data={{
								id: token.id,
								name: token.name
							}}
						/>
					</td>
				</tr>
			{:else}
				<h4>No API tokens generated yet</h4>
			{/each}
			<tr class="api-cta-container">
				<td colspan="5">
					<InlineNotification
						icon={'api_info'}
						centered={true}
						message={'Need more API Calls? Increase your plan by contacting our'}
					>
						<a href="/help" class="api-cta"> Customer Support </a></InlineNotification
					>
				</td>
			</tr>
		</tbody>
	</TableView>
{:catch}
	No tokens
{/await}

<style>
	h4 {
		color: var(--t-c-lx);
	}
	.statistics {
		margin: 1em 0 2em;
	}
	.statistics-header {
		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		color: var(--t-c-lx);
		margin-bottom: 0.5em;
	}
	.statistics-header h3 {
		font-size: 1rem;
		font-weight: 100;
	}
	.usage span:first-of-type {
		font-weight: 700;
		font-size: 2rem;
		color: var(--t-c);
	}
	.usage-period span {
		color: var(--t-c);
	}
	.token-info {
		display: flex;
		align-items: center;
		justify-content: space-between;
		max-width: 70%;
	}
	.token-color {
		--bg-color: #0c01a3;
		--size: 12px;
		display: inline-block;
		background-color: var(--bg-color);
		min-width: var(--size);
		min-height: var(--size);
		border-radius: 2px;
		margin-right: 5px;
	}
	.token-name {
		font-size: 16px;
		margin-bottom: 3px;
	}
	.copy-token:hover :global(path) {
		fill: var(--h-c);
	}
	.token {
		display: inline-block;
		max-width: 20ch;
		overflow: hidden;
		text-overflow: ellipsis;
		color: var(--t-c-lx);
		font-size: 12px;
	}
	.api-cta-container td {
		padding-right: unset;
	}
	.api-cta-container :global(div) {
		line-height: 1;
		background-color: #f5f5f7;
		padding: 0.5em;
	}
	.api-cta {
		margin-left: 5px;
		color: var(--h-c);
		text-decoration: underline !important;
		font-size: 14px;
		white-space: nowrap;
	}
	.statistics :global(.bar-wrapper) {
		margin-bottom: 0.5em;
	}
</style>
